// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"670":"25336716","703":"aaefe0cb"}[chunkId] + ".chunk.css";
};